import { type Vec2, add, mul } from "../math/Vec2.js";
import { tuning } from "../state/tuning.js";
import type { PlayerState } from "../state/types.js";

export function computeStickAnchor(player: PlayerState): Vec2 {
  return add(player.pos, mul(player.stickDir, tuning.puck.controlAnchorDistance));
}

/** True if the puck is within stick reach AND roughly in front of the player. */
export function isPuckInStickZone(player: PlayerState, puckPos: Vec2): boolean {
  const dx = puckPos.x - player.pos.x;
  const dy = puckPos.y - player.pos.y;
  const dist = Math.sqrt(dx * dx + dy * dy);
  const reach = tuning.puck.controlAnchorDistance + tuning.puck.radius + 0.2;
  if (dist > reach) return false;
  if (dist === 0) return true;
  // Within a forward 180° cone.
  const dotForward = (dx * player.stickDir.x + dy * player.stickDir.y) / dist;
  return dotForward > 0.2;
}

/** Wider, shorter zone used for stick-lift puck strips. */
export function isPuckInLiftZone(player: PlayerState, puckPos: Vec2): boolean {
  const dx = puckPos.x - player.pos.x;
  const dy = puckPos.y - player.pos.y;
  const dist = Math.sqrt(dx * dx + dy * dy);
  if (dist > tuning.puckStrip.stickLiftReach) return false;
  if (dist === 0) return true;
  const dotForward = (dx * player.stickDir.x + dy * player.stickDir.y) / dist;
  return dotForward > tuning.puckStrip.stickLiftConeDotMin;
}
